import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Btn, Field, SlideOver, TextInput, ui } from "../ui";

// Sends the transcript and summary to one address, BCCing the signed-in user.
// email: useEmailCall's mutation.
export function CallEmailPanel({ email, onClose }) {
  const [to, setTo] = useState("");
  const { reset } = email;
  useEffect(() => reset(), [reset]);
  // A bad address comes back as a 422 on to_email, shown under the field
  const fieldError = email.error?.response?.data?.errors?.to_email?.[0];

  const send = (e) => {
    e.preventDefault();
    const address = to.trim();
    if (!address || email.isLoading) return;
    email.mutate(address, {
      onSuccess: () => {
        toast.success(`Email sent to ${address}`);
        onClose();
      },
      onError: (err) => {
        if (!err.response?.data?.errors?.to_email) {
          toast.error("Failed to send email. Please try again.");
        }
      },
    });
  };

  return (
    <SlideOver label="Email notes" onClose={onClose}>
      <form
        onSubmit={send}
        style={{ display: "flex", flexDirection: "column", gap: "12px" }}
      >
        <p
          style={{ ...ui.muted, margin: 0, fontSize: "13px", lineHeight: 1.5 }}
        >
          Sends the call transcript and summary to the address you enter, and
          BCCs you so you have a record of what was sent.
        </p>
        <Field label="Email address" htmlFor="call-email-to" error={fieldError}>
          <TextInput
            id="call-email-to"
            type="email"
            value={to}
            autoFocus
            maxLength={100}
            placeholder="name@example.com"
            onChange={(e) => {
              setTo(e.target.value);
              if (email.error) email.reset();
            }}
            invalid={!!fieldError}
          />
        </Field>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            paddingTop: "12px",
          }}
        >
          <Btn variant="ghost" onClick={onClose} disabled={email.isLoading}>
            Cancel
          </Btn>
          <Btn
            as="button"
            type="submit"
            variant="primary"
            loading={email.isLoading}
            disabled={!to.trim()}
          >
            Send
          </Btn>
        </div>
      </form>
    </SlideOver>
  );
}
